import  {   Component, ElementRef, EventEmitter, Input, Output, ViewChild         } from '@angular/core';

import  {   User              } from 'src/app/beans/login/user/user.bean';
import  {   HandlerManager    } from 'src/app/managers/handler/handler.manager';
import  {   SessionManager    } from 'src/app/managers/session/session.manager';
import  {   Place             } from 'src/app/beans/place/place.bean';
import  {   MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger   } from '@angular/material/autocomplete';
import  {   FormControl       } from '@angular/forms';
import  {   Observable, of        } from 'rxjs';
import  {   map               } from 'rxjs/operators';
import  {   COMMA, ENTER      } from '@angular/cdk/keycodes';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { pl } from 'date-fns/locale';

@Component
({
  selector: 'place-autocomplete',
  templateUrl: './place.autocomplete.html',
  styleUrls: ['./place.autocomplete.scss']
})

export class PlaceAutocomplete
{
  visible             : boolean               = true              ;
  separatorKeysCodes  : number[]              = [ENTER, COMMA]    ;
  placeCtrl           : FormControl           = new FormControl() ;
  filteredPlaces      : Observable<Place[]>                       ;
  places              : Place[]               = []                ;

  place               : Place

  preselect           : { id: number, name: string}
  @Input('preselect') set _preselect( preselect : { id: number, name: string} ) {
    this.recoveryPlace( preselect )
    this.preselect = preselect
  }

  @Output   ('placeChange'    ) placeChange: EventEmitter<Place> = new EventEmitter()

  @ViewChild( 'placeInput'    ) placeInput      : ElementRef<HTMLInputElement>;
  @ViewChild( 'auto'          ) matAutocomplete : MatAutocomplete             ;

  @ViewChild( 'placeInput'   , { read: MatAutocompleteTrigger  } ) placeTrigger: MatAutocompleteTrigger;

  constructor(
    private _session: SessionManager,
    private _loader : LoadingManager,
    private _handler: HandlerManager
  ) {
    this.placeCtrl.valueChanges.subscribe(
      async (place: string | Place) =>{
        if(Place.isKind( place )){
          this.place = place as Place
          place = (place as Place).name
        }
        this.filteredPlaces = of( await this._filter(place as string ) )
      }
    )
  }

  async recoveryPlace ( preselect : { id: number, name: string} ) {
    const list  = await this._filter( preselect.name )
    const place = list.find( place => place.id == preselect.id ) 
    if( place ){
      this.place = place 
      this.placeCtrl.setValue( place )
    }
  }

  async retrivePlaceList( text: string )
  {    
    
    const user  = this._session.user().get()

    if (!User.isKind( user )) return // TODO handle user incorrect 


    let response = null

    response = await this._handler.place().list(( user as User ).token, text ? text.toLowerCase() : null )


    if ( !response        ) return
    if ( !response.list   ) return

    //this.places = response.list
    return response.list as Place[]
  }

  
  displayFn(place: Place): string 
  {
    return place && place.name ? place.name : '';
  }

  remove(place: Place): void {
    const index = this.places.indexOf(place);

    if (index >= 0) {
      this.places.splice(index, 1);
    }
  }

  async selected(event: MatAutocompleteSelectedEvent ): Promise<void> {
    this.places.push(event.option.value);
    //await this.focused()
    this.placeChange.emit( event.option.value )
    //setTimeout( ()=>{ this.placeTrigger.openPanel()}, 100)
  }

  async _filter(value: string | Place ) {   
     
    if (value && (typeof value === 'string') ) 
      return await  this.retrivePlaceList( value.toLowerCase() )
    else if ( Place.isKind( value )) 
      return await  this.retrivePlaceList( (value as Place).name )
    else
      return await  this.retrivePlaceList( null )
  }

  getSelected(){
    return this.places ? this.places : []
  }

  async focused(param?: any){
    const place = this.placeCtrl.value
    this.filteredPlaces = of( await this._filter(place) )

      //setTimeout( ()=>{ this.placeTrigger.openPanel()}, 100)
  }

  public clear(){
    this.placeCtrl.setValue(null)
    this.place = null
  }

  public reselect(){
    this.recoveryPlace( this.preselect )
  }


}
